import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
import { soulWiseTheme } from '../../mui-theme';

export const SWLink = styled(Link)(({ theme }) => ({
  color: soulWiseTheme.palette.greenLight,
  textDecorationColor: soulWiseTheme.palette.greenLight,
}));
